const URL = (val) => {
    const regex = '^((https?)://)?(www.)?[a-z0-9]+(.[a-z0-9]+)+([/?].*)?$';

    const valid = !val || new RegExp(regex).test(val);

    return [
        valid,
        valid ? null : 'Please enter a valid web address.',
    ]
}

export default URL;